<template>
  <ApolloMutation
    :mutation="gql => gql`
      mutation DeleteMediaObject($id: ID!) {
      deleteMediaObject(input: {id: $id}) {
        mediaObject {
          id
          contentUrl
        }
      }
    }
    `"
    :variables="{
      id: id,
    }"
    :update="mediaObjectDeleted"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn
        class="rounded-xl pa-3"
        small
        :elevation="0"
        @click="confirmDeletion(mutate)"
        :disabled="loading"
        :loading="loading"
        color="error"
      >
        <v-icon class="mr-2">$trash</v-icon>
        <span>
          {{ $t("mediaObject.removeFile") }}
        </span>
      </v-btn>
      <DeleteConfirmationModal :deleteGuardNamespace="DELETE_GUARD_NAMESPACE" :key="DELETE_GUARD_NAMESPACE" />
    </template>
  </ApolloMutation>
</template>

<script>
import hasDeleteGuard from "@/mixins/hasDeleteGuard";
import DeleteConfirmationModal from "@/components/DeleteConfirmationModal"
export default {
  mixins: [hasDeleteGuard],
  components: {
    DeleteConfirmationModal,
  },
  props: {
    id: String,
    type: String,
  },
  created() {
    this.$store.commit(`${this.DELETE_GUARD_NAMESPACE}/setType`, 'mediaObject.' + this.type)
  },
  methods: {
    confirmDeletion(mutate) {
      this.$store.dispatch(`${this.DELETE_GUARD_NAMESPACE}/show`, { callback: mutate })
    },
    mediaObjectDeleted() {
      this.$emit('deleted')
    },
  }
};
</script>